
export =
    [{

        "fill": {
            "pattern": {
                "orientation": "horizontal",
                "color": "rgba(115,38,12,1)",
                "spacing": 6,
                "repitition": "repeat"
            }
        }
    }];